export default __webpack_public_path__ + "static/media/boss.3881355e.jpg";